import {useLocation} from 'react-router-dom';
import type {BreadcrumbItem} from '@/components/breadcrumbs/Breadcrumbs';
import {OFF_PLATFORM_BREADCRUMB_ROUTES} from '../breadcrumbRouteDefinitions';
import {matchBreadcrumbRoutes} from '../breadcrumbRouteTypes';
import usePreservedSearchString from '../usePreservedSearchString';
import useContentSubmissionBreadcrumbData from './useContentSubmissionBreadcrumbData';

function useOffPlatformBreadcrumbItems(): BreadcrumbItem[] | null {
  const {pathname} = useLocation();
  const preservedSearch = usePreservedSearchString();

  const matched = matchBreadcrumbRoutes(
    OFF_PLATFORM_BREADCRUMB_ROUTES,
    pathname
  );

  const {campaignId, contentSubmissionId} = matched?.params ?? {};

  const data = useContentSubmissionBreadcrumbData({
    campaignId,
    contentSubmissionId,
  });

  if (!matched) return null;

  // Append the preserved search (the share token) to every crumb link so it
  // survives breadcrumb navigation. No `i > 0` guard like
  // useCampaignBreadcrumbItems: the first off-platform crumb is the review
  // page itself, which also needs the token.
  return matched.route
    .getItems(matched.params, data)
    .filter((item) => item.label)
    .map((item) =>
      item.link ? {...item, link: item.link + preservedSearch} : item
    );
}

export default useOffPlatformBreadcrumbItems;
